/** @format */

export const APP_VERSION = '4.1.86';

export const ENABLE_REDUX_DEV_TOOLS = true;

export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK',
  UNICORN: 'UNICORN'
};

export const ENDPOINTS = {
  // User
  GET_USER_ENDPOINT: '/api/user',
  GET_USER_INFO_ENDPOINT: '/api/user/info',
  ONBOARDING_COMPLETE_ENDPOINT: '/api/v1/users',

  //Widget
  GET_WIDGET_ENDPOINT: 'api/widgets/dashboard',
  GET_PUBLIC_CONTENT_INFO_ENDPOINT: 'api/public/content',
  GET_PRIVATE_CONTENT_INFO_ENDPOINT: 'api/content',
  GET_DASHBOARD_ENDPOINT: 'api/widgets/sub-dashboard/',

  // Footer
  GET_FOOTER_LINKS_ENDPOINTS: 'api/public/footer/links',

  // Dashboard Config
  SET_DASHBOARD_LAYOUT: 'api/dashboards/config',

  // Download tracking
  TRACK_DOWNLOAD_ENDPOINT: 'api/v1/tracking/track',

  // Tickets
  GET_TICKETS_ENDPOINT: 'api/v1/incidents',
  GET_TICKETS_COMPANY_ENDPOINT: 'api/v1/account/incidents',
  GET_TICKETS_ADDRESSES_ENDPOINT: 'api/v1/pathfinder/addresses',

  // Knowledge Base
  GET_KNOWLEDGE_BASE_ENDPOINT: 'api/v1/kb',
  GET_KNOWLEDGE_BASE_CATEGORIES_ENDPOINT: 'api/v1/kb/categories',
  GET_KNOWLEDGE_BASE_VOTE_ENDPOINT: 'api/v1/kb/vote',

  // News
  GET_NEWS_ENDPOINT: 'api/v1/news',
  GET_NEWS_CATEGORIES_ENDPOINT: 'api/v1/news/categories',
  GET_NEWS_VOTE_ENDPOINT: 'api/v1/news/vote'
};

export const ACTION_CONSTANTS = {
  /**
   * User
   */
  USER_LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
  USER_LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
  USER_LOGIN_FAIL: 'USER_LOGIN_FAIL',
  USER_UPDATE_REQUEST: 'USER_UPDATE_REQUEST',
  USER_UPDATE_SUCCESS: 'USER_UPDATE_SUCCESS',
  USER_UPDATE_FAIL: 'USER_UPDATE_FAIL',

  USER_UPDATE_DATA: 'USER_UPDATE_DATA',

  ON_BOARDING_COMPLETE: 'ON_BOARDING_COMPLETE'
};

export const VALIDATE_REGEX = {
  email: /[a-zA-Z0-9._]*@[a-zA-Z0-9.-]*\.[a-z]*/,
  phone: /^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$/im,
  password:
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!,;`~'":{}<>^/@#$%^&*?|\\[\]\\)(+=._-])([a-zA-Z0-9!,;`~'":{}<>^/@#$%^&*?|\\[\]\\)(+=._-]){8,30}$/
};

export const TICKET_STATUS = {
  new: 'new',
  'in progress': 'in progress',
  pending: 'pending',
  resolved: 'resolved',
  cancelled: 'cancelled',
  closed: 'closed'
};

export const TICKET_MODAL = {
  CREATE_TICKET: 'CREATE_TICKET',
  UPDATE_TICKET: 'UPDATE_TICKET',
  UPDATE_POSTALCODE: 'UPDATE_POSTALCODE',
  CLOSE_TICKET: 'CLOSE_TICKET',
  TOLLING_CUSTOMER_SELECTION: 'TOLLING_CUSTOMER_SELECTION'
};

export const API_URL = process.env.REACT_APP_API_URL;
export const IS_PRODUCTION = process.env.REACT_APP_ENV === 'live';

export const MAX_NUMBER_OF_FILES = 3;
export const MAX_FILE_SIZE = 20; // (MB)
export const MAX_FILE_SIZE_TEXT = 20; // (MB)

export const LANGUAGES = [
  {
    title: 'English',
    value: 'en',
    market: 'International'
  },
  {
    title: 'Français',
    value: 'fr',
    market: 'France'
  },
  {
    title: 'Deutsch',
    value: 'de',
    market: 'Deutschland'
  },
  {
    title: 'Español',
    value: 'es',
    market: 'España'
  },
  {
    title: 'Italiano',
    value: 'it',
    market: 'Italia'
  },
  {
    title: 'Dutch',
    value: 'nl',
    market: 'Netherlands'
  },
  {
    title: 'Dutch',
    value: 'nl-BE',
    market: 'Belgium'
  },
  {
    title: 'Polish',
    value: 'pl',
    market: 'Poland'
  },
  {
    title: 'Deutsch',
    value: 'de-AT',
    market: 'Österreich'
  },
  {
    title: 'English',
    value: 'en-IE',
    market: 'Ireland'
  },
  {
    title: 'English',
    value: 'en-GB',
    market: 'United Kingdom'
  },
  {
    title: 'Bulgarian',
    value: 'bg',
    market: 'Bulgaria'
  },
  {
    title: 'Czech',
    value: 'cs',
    market: 'Czech Republic'
  },
  {
    title: 'Slovak',
    value: 'sk',
    market: 'Slovakia'
  },
  {
    title: 'Hungarian',
    value: 'hu',
    market: 'Hungary'
  },
  {
    title: 'Serbian',
    value: 'sr',
    market: 'Serbia'
  },
  {
    title: 'Croatian',
    value: 'hr',
    market: 'Croatia'
  },
  {
    title: 'Bosnian',
    value: 'bs',
    market: 'Bosnia and Herzegovina'
  },
  {
    title: 'Danish',
    value: 'da',
    market: 'Denmark'
  },
  {
    title: 'Romanian',
    value: 'ro',
    market: 'Romania'
  },
  {
    title: 'Estonian',
    value: 'et',
    market: 'Estonia'
  },
  {
    title: 'Finnish',
    value: 'fi',
    market: 'Finland'
  },
  {
    title: 'Greek',
    value: 'el',
    market: 'Greece'
  },
  {
    title: 'Icelandic',
    value: 'is',
    market: 'Iceland'
  },
  {
    title: 'Latvian',
    value: 'lv',
    market: 'Latvia'
  },
  {
    title: 'Lithuanian',
    value: 'lt',
    market: 'Lithuania'
  },
  {
    title: 'Norwegian',
    value: 'no',
    market: 'Norway'
  },
  {
    title: 'Portuguese',
    value: 'pt',
    market: 'Portugal'
  },
  {
    title: 'Portuguese',
    value: 'pt-BR',
    market: 'Brazil'
  },
  {
    title: 'Slovenian',
    value: 'sl',
    market: 'Slovenia'
  },
  {
    title: 'Swedish',
    value: 'sv',
    market: 'Sweden'
  },
  {
    title: 'Turkish',
    value: 'tr',
    market: 'Turkey'
  },
  {
    title: 'Swiss',
    value: 'de-CH',
    market: 'Switzerland'
  }
];

/** Page ID for onboarding flow; URL is /page/${ONBOARDING_PAGE_ID} */
export const ONBOARDING_PAGE_ID = process.env.REACT_APP_ONBOARDING_PAGE_ID;
export const HELP_DASHBOARD_ID = process.env.REACT_APP_HELP_DASHBOARD_ID;

// Feature flags for live environment
export const FEATURE_FLAGS = {
  TICKET_EXTENSION: true
};
